'use client';

import type { DraggableProvidedDragHandleProps } from '@hello-pangea/dnd';
import { Icons } from '@/components/icons';

interface DragHandleProps {
  readonly dragHandleProps: DraggableProvidedDragHandleProps | null | undefined;
}

export const DragHandle = ({ dragHandleProps }: DragHandleProps) => {
  if (!dragHandleProps) return null;

  return (
    <div
      aria-label='Dra för att flytta'
      title='Dra för att flytta'
      {...dragHandleProps}
      className='flex shrink-0 cursor-grab items-center pl-4'
      role='button'
    >
      <Icons.menu className='size-4 text-muted-foreground transition-colors duration-200 hover:text-foreground' />
    </div>
  );
};
